import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { reduxForm } from 'redux-form';
import messages from '../../../text/messages';
import WizardButtons from '../../wizard/navigator/buttons';

class ImpersonateAgreement extends React.Component {
    constructor(props) {
        super(props);

        this.getMessages = this.getMessages.bind(this);
    }

    getMessages() {
        const { role, exiting } = this.props;

        if (!exiting) {
            return {
                title: (
                    <FormattedHTMLMessage
                        id={'impersonate.confirm'}
                        defaultMessage={"Take control of {role}'s account?"}
                        values={{ role: role.type }}
                        tagName={'h4'}
                    />
                ),
                submit: <FormattedMessage id={'impersonate.agreeSubmit'} defaultMessage={"Yes, assume {role}'s role"} values={{ role: role.type }} />
            };
        }

        return {
            title: <FormattedMessage id={'impersonate.exitConfirm'} defaultMessage={'Exit impersonate mode?'} values={{ role: role.type }} tagName={'h4'} />,
            submit: <FormattedMessage id={'impersonate.exit'} defaultMessage={'Yes, Exit'} />
        };
    }

    render() {
        const { role, cancel, handleSubmit, onSubmit, submitting } = this.props;
        if (!role) return null;

        const { title, submit } = this.getMessages();

        return (
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                    <div className="col-xs-12 text-center">{title}</div>
                </div>
                <WizardButtons
                    disabled={submitting}
                    back={{ action: cancel, message: <FormattedMessage {...messages.cancel} /> }}
                    submit={{ message: submit }}
                />
            </form>
        );
    }
}

ImpersonateAgreement.defaultProps = {
    role: undefined,
    cancel: () => null
};
ImpersonateAgreement.propTypes = {
    role: PropTypes.object.isRequired,
    cancel: PropTypes.func.isRequired
};

ImpersonateAgreement = reduxForm({
    form: 'impersonate-agreement-dialog'
})(ImpersonateAgreement);

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ImpersonateAgreement);



// WEBPACK FOOTER //
// ./src/components/roleSelector/components/impersonateAgreement.jsx